// STUDIO-BLUETOOTH-QUICK-REGISTER-1 · 보조자 콘솔 · Studio 셔터 캡처 전달함 (방송별 · 기존 빠른등록으로 등록).
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { Camera, X } from 'lucide-react';
import api from '@/lib/api';

const POLL_MS = 5000;

export const CaptureInbox = ({ scheduleId, onRegister }) => {
  const [items, setItems] = useState([]);
  const sidRef = useRef(scheduleId);
  const load = useCallback(async () => {
    if (!scheduleId) return;
    try {
      const r = await api.get(`/seller/live/${scheduleId}/captures`);
      if (sidRef.current === scheduleId) setItems(r.data.items || []);
    } catch { /* 다음 주기 재시도 */ }
  }, [scheduleId]);
  useEffect(() => {
    sidRef.current = scheduleId;
    setItems([]);
    load();
    const t = setInterval(load, POLL_MS);
    return () => clearInterval(t);
  }, [load]);

  const register = async (c) => {
    try {
      const blob = await (await fetch(`${process.env.REACT_APP_BACKEND_URL}${c.image_url}`)).blob();
      onRegister(new File([blob], `${c.capture_id}.jpg`, { type: blob.type || 'image/jpeg' }), c);
    } catch { toast.error('캡처 이미지를 불러오지 못했어요'); }
  };
  const dismiss = async (c) => {
    try { await api.patch(`/seller/live/${scheduleId}/captures/${c.capture_id}`, { status: 'dismissed' }); load(); } catch { load(); }
  };

  if (!scheduleId) return null;
  return (
    <div className={`rounded-xl p-2.5 ${items.length ? 'border-2 border-[#FF3B30]/40 bg-[#FF3B30]/5' : 'border border-dashed border-black/15 dark:border-white/15'}`}
         data-testid="live-capture-inbox" data-schedule-id={scheduleId}>
      <p className={`text-[11px] font-black inline-flex items-center gap-1 ${items.length ? 'text-[#FF3B30]' : 'text-gray-500'}`}
         data-testid="live-capture-inbox-title"><Camera size={12} /> 캡처 전달함 ({items.length}건)</p>
      {!items.length && (
        <p className="mt-1 text-[11px] text-gray-500" data-testid="live-capture-inbox-empty">
          Studio에서 보조자 등록 모드로 캡처하면 여기에 표시됩니다.
        </p>
      )}
      {items.length > 0 && <div className="mt-2 flex gap-2 overflow-x-auto">
        {items.map((c) => (
          <div key={c.capture_id} className="shrink-0 w-28" data-testid={`live-capture-${c.capture_id}`}>
            <img src={`${process.env.REACT_APP_BACKEND_URL}${c.image_url}`} alt="상품 캡처" className="w-28 h-28 object-cover rounded-lg border border-black/10" />
            <div className="mt-1 flex gap-1">
              <button type="button" onClick={() => register(c)} className="flex-1 min-h-[28px] rounded-full bg-[#FF3B30] text-white text-[11px] font-black"
                      data-testid={`live-capture-register-${c.capture_id}`}>등록</button>
              <button type="button" onClick={() => dismiss(c)} aria-label="보관 해제" title="보관 해제" className="min-h-[28px] px-2 rounded-full border border-black/15 text-[11px]"
                      data-testid={`live-capture-dismiss-${c.capture_id}`}><X size={11} /></button>
            </div>
          </div>
        ))}
      </div>}
    </div>
  );
};

export const markCaptureRegistered = (scheduleId, captureId, productId) =>
  api.patch(`/seller/live/${scheduleId}/captures/${captureId}`, { status: 'registered', product_id: productId || null });

export default CaptureInbox;
